import React from 'react';
import { BanIcon, BatteryLowIcon, HelpCircleIcon, MoonIcon, PillIcon, RefreshCwIcon, FrownIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { costOfInaction } from '../../data/landing';
const icons = [PillIcon, FrownIcon, BanIcon, HelpCircleIcon, MoonIcon, BatteryLowIcon, RefreshCwIcon];
export function CostOfInaction() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-81" data-mp="2gwsdcd2etavd">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-82" data-mp="2cu5s4v08uo75">
        <div className="text-center lg:text-left" data-id="element-83" data-mp="281cokagihlwn">
          <h2 className="text-4xl font-black uppercase leading-[1] tracking-tight text-brand md:text-6xl" data-id="element-84" data-mp="280jdixaisa8p">
            ¿Cuánto cuesta <span className="text-danger" data-id="element-85" data-mp="1y4q59q3u32wq">no tenerlo?</span>
          </h2>
          <p className="mt-8 text-3xl font-black leading-snug text-brand md:text-4xl" data-id="element-86" data-mp="1y2deqok0fk82">
            “El próximo domingo puede ser <Highlight data-id="element-87" data-mp="1p3s0h5lkmrd3">diferente.</Highlight>”
          </p>
        </div>

        <div className="rounded-3xl border border-danger/20 bg-danger-soft p-6 md:p-8" data-id="element-88" data-mp="1p5miab1jq3cy">
          <p className="text-sm font-black uppercase tracking-[0.2em] text-danger" data-id="element-89" data-mp="mbw0xnxh93rd">Sin MegaPack</p>
          <ul className="mt-4 divide-y divide-danger/15" data-id="element-90" data-mp="r58ije3qoaam">
            {costOfInaction.map((c, i) => {
            const Icon = icons[i];
            return <li key={c.title} className="flex items-center gap-4 py-3.5" data-id="element-91" data-mp="hdkvrqi4nhfh" data-mpi={i}>
                  <Icon className="h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-92" data-mp="153ovvnw3wz1q" />
                  <span className="font-bold text-charcoal" data-id="element-93" data-mp="151vog6do6aso">{c.title}</span>
                  <span className="ml-auto text-right text-sm text-muted" data-id="element-94" data-mp="1a29ph4guskh7">{c.detail}</span>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}